<template>
  <div id="app" style="">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
           this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 28px;
  padding: 28px 32px;
  line-height: 1.45;
  width: auto !important;
  min-width: 280px;
  max-width: 620px;
  white-space: normal;
  word-break: break-word;
  background: linear-gradient(180deg, #fc78af, #f22678) !important;
}
body .van-toast .van-toast__text {
  font-size: 28px;
  line-height: 1.45;
  margin-top: 8px;
}
body .van-toast .van-toast__icon {
  font-size: 44px;
}
*, :after, :before {
  box-sizing: border-box;
}
body .ban-tip-dialog .van-dialog__message {
  font-size: 56px;
  line-height: 1.5;
  padding: 72px 48px 48px;
  color: #222;
  font-weight: 700;
}
body .ban-tip-dialog .van-dialog__footer .van-button {
  height: 100px;
  font-size: 36px;
}
</style>
